import { SnackbarActionTypes, SHOW_SNACKBAR, HIDE_SNACKBAR } from './actionType';
import { initialSnackbarState, SnackbarState } from './state';

const snackbarReducer = (state = initialSnackbarState, action: SnackbarActionTypes): SnackbarState => {
    switch (action.type) {
        case SHOW_SNACKBAR:
            return { ...state, message: action.payload.message, open: true };
        case HIDE_SNACKBAR:
            return { ...state, open: false };
        default:
            return state;
    }
};

export default snackbarReducer;
